import React, { Component } from 'react'
import PropTypes from 'prop-types'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import BootstrapTable from 'react-bootstrap-table-next'
import Heading from 'components/Heading'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'

class Table extends Component {
	render() {
		const { title, keyField = 'id', data, columns, expandRow, search = false, paginationSettings, classes = '', headerClasses, rowClasses = '' } = this.props
		const { SearchBar } = Search
		const pagination = paginationFactory({
			sizePerPageList: [{
				text: '5', value: 5
			}, {
				text: '10', value: 10
			}, {
				text: '15', value: 15
			}, {
				text: '20', value: 20
			}],
			...paginationSettings
		})

		return < ToolkitProvider
			// By default key field is `id`
			keyField={keyField}
			// Array of data objects
			data={data}
			// Array of column objects
			columns={columns}
			// Should search be shown
			search={search}
		>
			{
				props => <div className='o-layout u-text--normal'>
					<Heading text={title} classes='u-text--large u-heading-line u-heading-line-cornflower o-layout__item u-1/1 u-2/3@desktop u-1/2@tablet' />
					{
						search &&
						<div className='o-layout__item u-1/1 u-1/3@desktop u-1/2@tablet u-text--right'>
							<SearchBar
								className='c-input--border c-input--search u-width-100'
								placeholder='Търси'
								{...props.searchProps} />
						</div>
					}
					<BootstrapTable
						expandRow={expandRow}
						wrapperClasses='o-layout__item u-1/1'
						// Table classes
						classes={`c-table ${classes}`}
						// Header classes
						headerClasses={headerClasses}
						// Row classes
						rowClasses={`c-table__row ${rowClasses}`}
						// Pagination
						pagination={pagination}
						// No data indication (empty table)
						noDataIndication={() => (<p className='u-margin u-text--normal'>Не са намерени резултати.</p>)}
						{...props.baseProps}
					/>
				</div>
			}
		</ToolkitProvider >
	}
}

Table.propTypes = {
	title: PropTypes.string,
	keyField: PropTypes.string,
	data: PropTypes.array,
	columns: PropTypes.array,
	expandRow: PropTypes.object,
	search: PropTypes.bool,
	paginationSettings: PropTypes.object,
	classes: PropTypes.string,
	headerClasses: PropTypes.string,
	rowClasses: PropTypes.string,
}

export default Table
